<template>
  <header class="head-content">
    <el-row>
      <el-col :span="4">
        <div class="returnBtn" @click="returnBack">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </el-col>
      <el-col :span="16">
        <div class="title" v-if="title">{{title}}</div>
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="titleList">
          <el-tab-pane
            :label="item.name"
            :name="item.name"
            v-for="(item,index) in titleList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="4">
        <div class="saveBtn" @click="submit" v-if="showSave">保存</div>
      </el-col>
    </el-row>
  </header>
</template>
<script>
export default {
  props: ["title", "titleList", "active", "isShowSave"],
  data() {
    return {
      activeName: "",
      showSave: true
    };
  },
  mounted() {
    if (this.active) {
      this.activeName = this.active;
      this.setActive(this.active);
    }
    if (this.isShowSave !== undefined && !this.isShowSave) this.showSave = this.isShowSave;
  },
  methods: {
    returnBack() {
      this.$router.go(-1);
    },
    submit() {
      this.$emit("submit");
    },
    setActive(name) {
      for (let item of this.titleList) {
        if (name === item.name) {
          this.showSave = item.showSave;
        }
      }
    },
    handleClick(tab, event) {
      this.setActive(tab.name);
      this.$emit("getActive", this.activeName);
    }
  }
};
</script>
<style lang="less" scoped>
.head-content {
  width: 100%;
  height: 60px;
  line-height: 60px;
  box-shadow: 6px 0 10px rgba(167, 176, 194, 0.3);
  box-sizing: border-box;
  padding: 0 20px;
  text-align: center;
  .returnBtn {
    width: 60px;
    font-size: 16px;
    color: #b0b4be;
    text-align: left;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
  }
  .saveBtn {
    width: 96px;
    height: 36px;
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    border: 2px solid #3c7ce6;
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    color: #3c7ce6;
    line-height: 34px;
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 50px;
    margin: 0 auto !important;
  }
}
</style>
<style lang="less">
.head-content {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .el-tabs__item {
    font-size: 18px;
  }
  .el-tabs__nav-wrap::after {
    opacity: 0;
  }
}
</style>


